import React, { useEffect, useState } from "react";
import _ from 'lodash';
import { Textarea, LoadingOverlay, Skeleton } from '@mantine/core';
import { hasCookie, getCookie } from "cookies-next";
import { LoginModal } from "../modal";
import { Drawer } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { mobileViewWidth } from '../../config/site';
import { FiX } from 'react-icons/fi';
import { toast } from "@/libraries/swal";
import { _postURL } from "../../pages/api";
import { _getIfUserLikeNews, _getAllComment } from '../../libraries/common';
import { ProfilePicture } from "../common/image";
import moment from "moment";
import { BsArrowReturnRight } from "react-icons/bs";
import { useForm } from "@mantine/form";
import { ShareCommentModal } from '../../components/modal';

const CommentBox = (props) => {
    const { loginStatus, userCookies, data, setLoginModalOpen, setDrawerOpen, setCommentReplyMode, setCommentBoxReplyingMessage, setCommentBoxContent, setCommentReplyId } = props
    /*
    const [state, setState] = useState({
        commentCount: 888, commentLike: false
    });
    */
    const [commentLikeCount, setCommentLikeCount] = useState(_.toNumber(data?.total_like));
    const [commentLikeStatus, setCommentLikeStatus] = useState(data?.user_like);
    const [commentTotalCount, setCommentTotalCount] = useState(_.toNumber(data?.total_comment));
    const [commentLike, setCommentLike] = useState(false);

    /*
    const _setAll = () => {
        _setAllState({
            commentCount: state.commentCount+1,
            commentLike: !state.commentLike
        })
        // setCommentCount(prev => prev - 1);
        // setCommentLike(!commentLike);
    }
    
    const _setAllState = (data ={}) => {
        setState((prevState) => ({...prevState, ...data}) );
    } 
    */

    const _likeThis = async(comment_id) => {
        try {
            if(_.isEmpty(userCookies)){
                throw ("Please login to continue")
            }
            let req = {
                "ref_table": 'tbl_comment',
                "ref_id": comment_id
            }
            const response = await _postURL("/api/comment/likeThis", {...req});
            if(!_.isEmpty(response.data)){
                if(response.data.message == 'like') {
                    setCommentLikeStatus(true);
                    setCommentLikeCount(prev => prev + 1);
                }
                else{
                    setCommentLikeStatus(false);
                    setCommentLikeCount(prev => prev - 1);
                }
            }
        } catch (error) {
            toast.error(error)
        }
    }

    const _replyMessage = async(comment_id) => {
        try {
            setCommentReplyMode(true);
            setCommentBoxReplyingMessage('Replying to ' + data?.first_name + ' ' + data?.last_name);
            setCommentBoxContent('Write a reply...')
            setCommentReplyId(comment_id);
        } catch (error) {
            toast.error(error)
        }
    }

    return (
        <div className="commentDrawer_commentEntry">
            <div className="commentDrawer_commentReply" style={{ display: data?.child ? 'unset' : 'none' }}></div>
            <ProfilePicture 
                size={5}
                imagePath={!_.isEmpty(data.profile_image) ? process.env.NEXT_PUBLIC_FS_URL + data.profile_image : undefined}
            />
            <div className="commentDrawer_commentDetail">
                <p className="fontSize_14 fontWeight_bold">{data?.first_name} {data?.last_name}</p>
                <p className="fontSize_14">{data?.content}</p>
                <div className="commentDrawer_commentDateLikeRow">
                    <div className="commentDrawer_commentDateLikeBox">
                        <p className="fontSize_14 fontColor_grey4">{moment(data?.comment_date).format('DD MMM')}</p>
                        <div className="commentDrawer_commentLikeReplyBox">
                            <p className="fontSize_14 fontWeight_semiBold fontColor_blue cursorPointer" onClick={ () => { loginStatus ? _likeThis(data?.comment_id) : setLoginModalOpen(true) } }>
                                { commentLikeStatus ? 'Dislike' : 'Like' }
                            </p>
                            {
                                !data?.child &&
                                <div className="commentDrawer_replyingMessage" onClick={ () => { _replyMessage(data?.comment_id) } }>
                                    <p className="fontSize_14 fontWeight_semiBold fontColor_blue cursorPointer">Reply</p>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="commentDrawer_commentLikeReplyStat">
                        <p className={`fontSize_14 ${commentLikeStatus ? "fontColor_blue" : "fontColor_grey4"}`}>{commentLikeCount}</p>
                        <div className="commentDrawer_StatImage">
                            { commentLikeStatus ? 
                                <img className="w-100" src="/assets/images/comment/comment_like_active.png" /> : 
                                <img className="w-100" src="/assets/images/comment/comment_like_grey.png" />
                            }
                        </div>
                        {
                            !data?.child &&
                            <>
                                <p className="fontSize_14 fontColor_grey4">{commentTotalCount}</p>
                                <div className="commentDrawer_StatImage">
                                    <img className="w-100" src="/assets/images/comment/comment_comment_grey.png" />
                                </div>
                            </>
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export const Comment = (props) => {
    const { t, data, commentList, setCommentList, drawerOpen, setDrawerOpen, loading = false } = props;
    const { width } = useViewportSize();

    const [commentLikeCount, setCommentLikeCount] = useState(_.toNumber(data?.total_like));
    const [commentTotalCount, setCommentTotalCount] = useState(_.toNumber(data?.total_comment));
    const [shareTotalCount, setShareTotalCount] = useState(_.toNumber(data?.total_share));
    const [commentLikeStatus, setCommentLikeStatus] = useState(false);

    //const [commentList, setCommentList] = useState(undefined);
    const [commentReplyMode, setCommentReplyMode] = useState(false);
    const [commentBoxContent, setCommentBoxContent] = useState('Write a comment...');
    const [commentBoxReplyingMessage, setCommentBoxReplyingMessage] = useState('');
    const [commentReplyId, setCommentReplyId] = useState(0);
    const [submitCommentStatus, setSubmitCommentStatus] = useState(false);

    // Share modal
    const [shareCommentOpen, setShareCommentOpen] = useState(false)

    // Check user login
    let userCookies;
    let isLogin;

    userCookies = getCookie("user") && JSON.parse(getCookie("user"));
    isLogin = !_.isEmpty(userCookies) ? true : false;

    // Login modal
    const [loginModalOpen, setLoginModalOpen] = useState(false);

    const { getInputProps, onSubmit, isValid, values, setFieldError, reset, setFieldValue, clearFieldError } = useForm({
        validateInputOnChange: true,
        initialValues: {
            content: '',
        },
        validate: {
            content: (inputValue) => inputValue.length <= 0 && "",
        }
    });

    // allow current user to like this
    const _likeThis = async() => {
        try{
            if(_.isEmpty(userCookies)){
                throw ("Please login to continue")
            }
            let req = {
                "ref_table": 'tbl_news',
                "ref_id": data?.news_id,
            }
            const response = await _postURL("/api/comment/likeThis", {...req});
            if(!_.isEmpty(response.data)){
                if(response.data.message == 'like') {
                    setCommentLikeStatus(true);
                    setCommentLikeCount(prev => prev + 1);
                }
                else{
                    setCommentLikeStatus(false);
                    setCommentLikeCount(prev => prev - 1);
                }
            }
        } catch (error) {
            toast.error(error)
        }
    }

    // add one to share count
    const _addShareCount = async() => {
        try{
            let req = {
                "news_id": data?.news_id,
            }
            const response = await _postURL("/api/comment/addShareCount", {...req});
            if(response.data > 0){
                setShareTotalCount(prev => prev + 1);
            }
        } catch (error) {
            toast.error(error)
        }
    }

    // when drawer open need to get current comment
    const _getAllCommentList = async() => {
        try{
            // get all comment
            await _getAllComment("tbl_news", data?.news_id, undefined, undefined, setCommentList);
        } catch(error) {
            console.log(error)
        }
    }

    // off reply mode
    const _offReplyMode = async() => {
        setCommentReplyMode(false);
        setCommentBoxContent('Write a comment...');
        setCommentReplyId(0);
    }

    // to submit new comment
    const _submitComment = async(value) => {
        setSubmitCommentStatus(true);
        try{
            if(_.isEmpty(userCookies)){
                setLoginModalOpen(true);
                // setCommentReplyMode(false);
                // setCommentBoxContent('Write a comment...');
                // setCommentBoxReplyingMessage('');
                // setCommentReplyId(0);
                setSubmitCommentStatus(false);
                reset();
                throw ("Please login to continue");
            }
            let req = {
                "ref_table": 'tbl_news',
                "ref_id": data?.news_id,
                "parent_id": commentReplyId,
                "content": value.content,
            }
            const response = await _postURL("/api/comment/createComment", {...req});
            if(!_.isEmpty(response)){
                await toast.success("Comment added");
                setCommentTotalCount(prev => prev + 1);
                await _getAllCommentList();
                setCommentReplyMode(false);
                setCommentBoxContent('Write a comment...');
                setCommentBoxReplyingMessage('');
                setCommentReplyId(0);
                setSubmitCommentStatus(false);
                reset();
            }
        } catch (error) {
            toast.error(error)
        }
    }

    useEffect(() => {
        const fetchData = async() => {
            try{
                // check if current login user already like this
                if(_.isEmpty(userCookies)){
                    setCommentLikeStatus(false);
                }
                else{
                    await _getIfUserLikeNews("tbl_news", data?.news_id, setCommentLikeStatus);
                }
            } catch(error) {
                console.log(error)
            }
        }
        fetchData()
        setCommentLikeCount(_.toNumber(data?.total_like));
        setCommentTotalCount(_.toNumber(data?.total_comment));
        // setCommentLikeStatus(false);
    }, [isLogin, data?.news_id]);

    // get all comment when page load
    useEffect(() => {
        // if(drawerOpen){
            const fetchData = async() => {
                try{
                    setCommentList(undefined);
                    await _getAllCommentList();
                } catch(error) {
                    console.log(error)
                }
            }
            fetchData()
        // }
    }, [isLogin, data?.news_id]);
    
    return (
        <>
            <div className="commentBoxOuter">
                <div className="commentBoxText">
                    <div className="commentBoxFakeInput cursorPointer" onClick={()=>{ setDrawerOpen(true) }}>
                        <span className="fontSize_14 fontColor_grey5">Write a comment...</span>
                    </div>
                    {/* <Textarea 
                        classNames={{
                            wrapper: "comment_textInput_wrapper",
                            input: "comment_textInput fontSize_14"
                        }}
                        placeholder='Write a comment...'
                        autosize
                        minRows={1}
                        disabled={true}
                    /> */}
                </div>
                <div className="commentBoxIconList">
                    <div onClick={ isLogin ? _.debounce(_likeThis, 500) : () => { setLoginModalOpen(true) } } className="commentBoxIcon cursorPointer">
                        <div className="commentBoxImage">
                            { commentLikeStatus ? 
                                <img className="w-100" src="/assets/images/comment/comment_like_active.png" /> : 
                                <img className="w-100" src="/assets/images/comment/comment_like.png" />
                            }
                        </div>
                        <div className="fontSize_12 fontWeight_semiBold fontColor_grey5">{commentLikeCount}</div>
                    </div>
                    <div className="commentBoxIcon cursorPointer" onClick={()=>{setDrawerOpen(true)}}>
                        <div className="commentBoxImage">
                            <img className="w-100" src="/assets/images/comment/comment_comment.png" />
                        </div>
                        <div className="fontSize_12 fontWeight_semiBold fontColor_grey5">{commentTotalCount}</div>
                    </div>
                    <div className="commentBoxIcon cursorPointer" onClick={ () => { setShareCommentOpen(true); _addShareCount();  } }>
                        <div className="commentBoxImage">
                            <img className="w-100" src="/assets/images/comment/comment_share.png" />
                        </div>
                        <div className="fontSize_12 fontWeight_semiBold fontColor_grey5">{shareTotalCount}</div>
                    </div>
                </div>
            </div>
            <Drawer 
                position="bottom" 
                opened={drawerOpen} 
                onClose={()=>{setDrawerOpen(false)}} 
                withinPortal={width <= mobileViewWidth ? true : false}
                size={'70%'}
                withCloseButton={false} 
                classNames={{
                    root: "commentDrawer_root",
                    drawer: "commentDrawer_drawer"
                }}
                styles={{
                    body: {height: '100%'}
                }}
                trapFocus={false}
            >
                <div>
                    <div className="commentDrawer_header">
                        <div className="commentDrawer_innerHeader">
                            <div className="commentDrawer_likeCount">
                                <p className="fontSize_16 fontWeight_semibold">
                                    {commentLikeCount} {t('peoples_like_this')}
                                </p>
                            </div>
                            <div className="commentDrawer_headerButton">
                                <div className="commentDrawer_headerLikeButton cursorPointer" onClick={ isLogin ? _.debounce(_likeThis, 500) : () => { setLoginModalOpen(true) } }>
                                    <div className="commentDrawer_headerImage">
                                        { commentLikeStatus ? 
                                            <img className="w-100" src="/assets/images/comment/comment_like_active.png" /> : 
                                            <img className="w-100" src="/assets/images/comment/comment_like.png" />
                                        }
                                    </div>
                                    <p className="fontSize_14 fontColor_blue">
                                        { commentLikeStatus ? t('dislike') : t('like') }
                                    </p>
                                </div>
                                <div className="commentDrawer_headerShareButton cursorPointer" onClick={ () => { setShareCommentOpen(true) } }>
                                    <div className="commentDrawer_headerImage">
                                        <img className="w-100" src="/assets/images/comment/comment_share_white.png" />
                                    </div>
                                    <p className="fontSize_14 fontColor_white">Share</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='commentDrawer_body'>
                        <div className="commentDrawer_box">
                            <p className="fontSize_18 fontWeight_bold">
                                {t('comments')} ({commentTotalCount})
                            </p>
                            <div className="commentDrawer_content">
                                {
                                    commentList == undefined ?
                                        _.reduce([1,2,3], (result, value, key)=>{
                                            result.push(
                                                <div className="commentDrawer_commentEntry" key={key}>
                                                    <Skeleton style={{ width: '5rem', height: '5rem', borderRadius: '50%' }} />
                                                    <Skeleton style={{ flex: 1, height: '10.5rem', borderRadius: '1rem' }} />
                                                </div>
                                            )
                                            return result
                                        },[])
                                    :
                                    !_.isEmpty(commentList) ? 
                                        _.reduce(commentList, (result, value, key)=>{
                                            result.push(
                                                <div className="commentDrawer_commentSection" key={key}>
                                                    <CommentBox 
                                                        loginStatus={isLogin} 
                                                        userCookies={userCookies} 
                                                        data={value} 
                                                        setLoginModalOpen={setLoginModalOpen} 
                                                        setDrawerOpen={setDrawerOpen} 
                                                        setCommentReplyMode={setCommentReplyMode} 
                                                        setCommentBoxReplyingMessage={setCommentBoxReplyingMessage} 
                                                        setCommentBoxContent={setCommentBoxContent} 
                                                        setCommentReplyId={setCommentReplyId} 
                                                    />
                                                    {
                                                        !_.isEmpty(value.sub) &&
                                                        _.reduce(value.sub, (result2, value2, key2)=>{
                                                            result2.push(
                                                                <div className="commentDrawer_commentSection" key={key2}>
                                                                    <CommentBox 
                                                                        loginStatus={isLogin} 
                                                                        userCookies={userCookies} 
                                                                        data={value2} 
                                                                        setLoginModalOpen={setLoginModalOpen} 
                                                                        setDrawerOpen={setDrawerOpen} 
                                                                        setCommentReplyMode={setCommentReplyMode} 
                                                                        setCommentBoxReplyingMessage={setCommentBoxReplyingMessage} 
                                                                        setCommentBoxContent={setCommentBoxContent} 
                                                                        setCommentReplyId={setCommentReplyId} 
                                                                    />
                                                                </div>
                                                            )
                                                            return result2
                                                        },[])
                                                    }
                                                </div>
                                            )
                                            return result
                                        },[])
                                    : 
                                    <div style={{ textAlign: 'center', padding: '2rem' }}>
                                        <p className="fontSize_14 fontWeight_semiBold">{t('no_comment_found')}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="commentBox_Sec containerPadding">
                        <LoadingOverlay visible={submitCommentStatus} overlayBlur={2} radius={'3rem'} loaderProps={{ size: "sm" }} />
                        { commentReplyMode && 
                            <div className="commentBox_ReplyChild cursorPointer" onClick={()=>{_offReplyMode()}}>
                                <BsArrowReturnRight style={{ width: '1.5rem', height: '1.5rem' }} />
                                <p className="fontSize_14 fontWeight_semiBold">{commentBoxReplyingMessage}</p>
                                <FiX className='commentBox_ReplyChild_closeIcon' />
                            </div>
                        }
                        <form onSubmit={onSubmit((values) => _submitComment(values))} className="commentBox_ReplyRow">
                            <div className="commentBoxText">
                                <Textarea 
                                    classNames={{
                                        wrapper: "comment_textInput_wrapper",
                                        input: "comment_textInput fontSize_14"
                                    }}
                                    placeholder={commentBoxContent}
                                    autosize
                                    minRows={1}
                                    {...getInputProps('content')}
                                />
                            </div>
                            <div className="commentBox_ReplyButton">
                                <button type="submit" disabled={isValid() ? false : true} className="commentBox_ReplyButtonInner cursorPointer">
                                    <p className="fontSize_16 fontWeight_semiBold fontColor_white">Post</p>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Drawer>
            <ShareCommentModal
                shareCommentOpen={shareCommentOpen}
                setShareCommentOpen={setShareCommentOpen}
                data={[]}
                t={t}
            />
            <LoginModal 
                opened={loginModalOpen}
                setOpened={setLoginModalOpen}
                t={t}
                isWriteReview={false}
                isWriteTyreReview={false}
            />
        </>
    )
}

export const CommentSection = (props) => {
    const { t, data, commentTotalCount, commentList, drawerOpen, setDrawerOpen, loading = false } = props;

    return (
        <div className="containerPadding" style={{ marginBottom: '1rem' }}>
            {
                commentList == undefined ?
                _.reduce([1,2,3], (result, value, key)=>{
                    result.push(
                        <div className="commentDrawer_commentEntry" key={key}>
                            <Skeleton style={{ width: '5rem', height: '5rem', borderRadius: '50%' }} />
                            <Skeleton style={{ flex: 1, height: '10.5rem', borderRadius: '1rem' }} />
                        </div>
                    )
                    return result
                },[])
                :
                !_.isEmpty(commentList) &&
                <>
                    <p className="fontSize_14 fontWeight_bold">
                        {t('comments')} ({commentTotalCount})
                    </p>
                    {
                        _.reduce(commentList, (result, value, key)=>{
                            result.push(
                                key <= 2 &&
                                <div className="commentDrawer_commentEntry" key={key}>
                                    <ProfilePicture 
                                        size={5}
                                        imagePath={!_.isEmpty(value.profile_image) ? process.env.NEXT_PUBLIC_FS_URL + value.profile_image : undefined}
                                    />
                                    <div className="commentDrawer_commentDetail">
                                        <p className="fontSize_14 fontWeight_bold">{value?.first_name} {value?.last_name}</p>
                                        <p className="fontSize_14">{value?.content}</p>
                                        <div className="commentDrawer_commentDateLikeRow">
                                            <div className="commentDrawer_commentDateLikeBox">
                                                <p className="fontSize_14 fontColor_grey4">{moment(value?.comment_date).format('DD MMM')}</p>
                                                <div className="commentDrawer_commentLikeReplyBox">
                                                    <p className="fontSize_14 fontWeight_semiBold fontColor_blue cursorPointer" onClick={ () => { setDrawerOpen(true) } }>
                                                        {t('like')}
                                                    </p>
                                                    <div className="commentDrawer_replyingMessage" onClick={ () => { setDrawerOpen(true) } }>
                                                        <p className="fontSize_14 fontWeight_semiBold fontColor_blue cursorPointer">{t('reply')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="commentDrawer_commentLikeReplyStat">
                                                <p className="fontSize_14 fontColor_grey4">{value?.total_like}</p>
                                                <div className="commentDrawer_StatImage">
                                                    <img className="w-100" src="/assets/images/comment/comment_like_grey.png" />
                                                </div>
                                                <p className="fontSize_14 fontColor_grey4">{value?.total_comment}</p>
                                                <div className="commentDrawer_StatImage">
                                                    <img className="w-100" src="/assets/images/comment/comment_comment_grey.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            return result
                        },[])
                    }
                    <div className="cursorPointer" style={{ display: 'flex', backgroundColor: '#E6FAFF', padding: '1rem', justifyContent: 'center', borderRadius: '2rem' }} onClick={ () => { setDrawerOpen(true) } }>
                        <p className="fontSize_14 fontWeight_semiBold fontColor_blue">{t('view_more')}</p>
                    </div>
                </>
            }
        </div>
    )
}